import axios from "axios";

// 创建拦截器
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 50000 // 如果请求时间了超过 `timeout` 的时间，请求将被中断
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    return config;
  },
  error => {
    // do something with request error
    console.log('发送请求失败', error); // for debug
    return Promise.reject(error);
  }
);

// 返回拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;
    return res;
  },
  error => {
    console.log(error);
    return Promise.reject(error);
  }
);
export default service;
